
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../../../shared/shared-imports';
import { customValidator } from '../../../../../Utils/validator';
import { Utils } from '../../../../../Utils/utils';

@Component({
  selector: 'app-add-activity',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './add-activity.component.html',
  styleUrl: './add-activity.component.scss'
})
export class AddActivityComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() data: any = "";
  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() onBtnClick = new EventEmitter<any>();
  form: FormGroup;

  // This method is used to initialize the class instance using fb
  constructor(
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      id: Utils.generateUniqueId(),
      codeFee: "",
      name: ["", [Validators.required, customValidator('english'), Validators.maxLength(100)]],
      description: ["", [Validators.required, customValidator('arabic'), Validators.maxLength(100)]],
      code: "",
      status: ""
    })
  }
  // This method is used to handle the on changes lifecycle hook using changes
  ngOnChanges(changes: SimpleChanges): void {
    if (this.data) {
      this.form.patchValue({
        id: this.data.id,
        codeFee: this.data.codeFee,
        name: this.data.descriptionOtherEn ?? this.data.name,
        description: this.data.descriptionOtherAr ?? this.data.description,
        code: this.data.code,
        status: this.data.status
      })
    }
  }
  // This method is used to submit activity
  submitActivity() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    let formData = this.form.value;
    this.onBtnClick.emit(formData);
    this.close();
  }

  // This method is used to close
  close() {
    this.isOpen = false;
    this.isOpenChange.emit(false);
  }
}
